import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './Coverage.css';
import { useGoogleTranslate } from '../GoogleTranslate'; // Adjust the import path as needed

const CoverageComponent = ({ defaultLanguage }) => {
  const { getCurrentLanguage } = useGoogleTranslate();
  const [currentLanguage, setCurrentLanguage] = useState(defaultLanguage || 'en');
  
  // Listen for language changes
  useEffect(() => {
    const checkLanguage = () => {
      const lang = getCurrentLanguage();
      setCurrentLanguage(lang);
    };
    
    // Initial check
    checkLanguage();
    
    // Set up an interval to check for language changes
    const intervalId = setInterval(checkLanguage, 1000);
    
    return () => clearInterval(intervalId);
  }, [getCurrentLanguage, defaultLanguage]);
  
  // Function to scroll to form section
  const scrollToForm = () => {
    const formSection = document.getElementById('form-section');
    if (formSection) {
      // Get the position of the element relative to the viewport
      const elementPosition = formSection.getBoundingClientRect().top;
      // Get the current scroll position
      const offsetPosition = elementPosition + window.pageYOffset;
      // Add an offset (e.g., -80px) to adjust the final position
      const offsetValue = -80; // Adjust this value as needed
      
      // Scroll to the element with the offset
      window.scrollTo({
        top: offsetPosition + offsetValue,
        behavior: 'smooth'
      });
    }
  };
  
  // Language-specific content
  const content = {
    en: {
      title: "What We'll Cover in Under an Hour",
      leftItems: [
        "How mortgages work—broken down simply",
        "How to qualify for a mortgage, even with low savings or credit",
        "What pre-approval means and why it matters",
        "How to compare lenders and avoid common mistakes"
      ],
      rightItems: [
        "Key mortgage terminology",
        "Popular loan products",
        "Down Payment Assistance (DPA) programs",
        "Common first-time buyer tips that many don't know"
      ],
      footer: "You'll walk away smarter, more confident, and ready to take the next step toward owning your home—on your terms.",
      buttonText: "Reserve Your Spot"
    },
    es: {
      title: "Lo Que Cubriremos en Menos de Una Hora",
      leftItems: [
        "Cómo funcionan las hipotecas, explicado de manera sencilla",
        "Cómo calificar para una hipoteca, incluso con ahorros bajos o crédito",
        "Lo que significa la pre-aprobación y por qué es importante",
        "Cómo comparar prestamistas y evitar errores comunes"
      ],
      rightItems: [
        "Términos clave de hipoteca",
        "Productos de préstamo populares",
        "Programas de Asistencia para el Pago Inicial (DPA)",
        "Consejos comunes para compradores de primera vez que muchos no conocen"
      ],
      footer: "Te irás más inteligente, más confiado y listo para dar el siguiente paso hacia la propiedad de tu casa—bajo tus propios términos.",
      buttonText: "Reserva Tu Lugar"
    }
  };
  
  // Select the appropriate content based on current language
  const { title, leftItems, rightItems, footer, buttonText } = content[currentLanguage] || content.en;
  
  return (
    <div className="coverage-component">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} className="text-center">
            <h2 className="banner-title notranslate" translate="no">{title}</h2>
          </Col>
        </Row>
        
        {/* Desktop view - Two columns */}
        <Row className="justify-content-center mt-4 desktop-view">
          <Col xs={12} lg={6}>
            <div className="info-box left-box">
              <ul className="info-list">
                {leftItems.map((item, index) => (
                  <li key={`left-${index}`} className="notranslate" translate="no">
                    <span className="check-icon">✓</span> {item}
                  </li>
                ))}
              </ul>
            </div>
          </Col>
          
          <Col xs={12} lg={6}>
            <div className="info-box right-box">
              <ul className="info-list">
                {rightItems.map((item, index) => (
                  <li key={`right-${index}`} className="notranslate" translate="no">
                    <span className="check-icon">✓</span> {item}
                  </li>
                ))}
              </ul>
            </div>
          </Col>
        </Row>
        
        {/* Mobile view - Single column with all list items */}
        <Row className="justify-content-center mt-4 mobile-view">
          <Col xs={12}>
            <div className="info-box left-box">
              <ul className="info-list">
                {[...leftItems, ...rightItems].map((item, index) => (
                  <li key={`mobile-${index}`} className="notranslate" translate="no">
                    <span className="check-icon">✓</span> {item}
                  </li>
                ))}
              </ul>
            </div>
          </Col>
        </Row>
        
        <Row className="justify-content-center mt-4">
          <Col xs={12} className="text-center">
            <p className="coverage-footer notranslate" translate="no">
              {footer}
            </p>
          </Col>
        </Row>
        
        <Row className="justify-content-center mt-4">
          <Col xs={12} className="text-center">
            <button 
              className="reserve-button notranslate" 
              translate="no"
              onClick={scrollToForm}
            >
              {buttonText}
            </button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CoverageComponent;